import { Helmet } from 'react-helmet-async';
import { useCurrentStore } from '@/hooks/useCurrentStore';

interface DashboardHeadProps {
  pageName: string;
}

export function DashboardHead({ pageName }: DashboardHeadProps) {
  const { currentStore } = useCurrentStore();
  const storeName = currentStore?.storeName || 'Store';
  const title = `${storeName} · ${pageName} · Sqaleshop`;
  const description = `Manage your ${storeName} store on Sqaleshop. ${pageName} dashboard for store management.`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="noindex, nofollow" />
      <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : ''} />
    </Helmet>
  );
}


